import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

/**
 * This is a exact copy of react-use/useIntersection but applies {@link https://github.com/streamich/react-use/pull/2306}
 *
 * @author Matt Vrydaghs
 */
const useIntersectionFix = (
  ref: RefObject<HTMLElement>,
  options: IntersectionObserverInit
): IntersectionObserverEntry | null => {
  const [intersectionObserverEntry, setIntersectionObserverEntry] =
    useState<IntersectionObserverEntry | null>(null);

  useEffect(() => {
    if (ref.current && typeof IntersectionObserver === 'function') {
      const handler = (entries: IntersectionObserverEntry[]) => {
        setIntersectionObserverEntry(entries[0]);
      };

      const observer = new IntersectionObserver(handler, options);
      observer.observe(ref.current);

      return () => {
        setIntersectionObserverEntry(null);
        observer.disconnect();
      };
    }
    return () => {};
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current, options.threshold.toString(), options.root, options.rootMargin]);

  return intersectionObserverEntry;
};

export default useIntersectionFix;
